import React, { useState } from "react";

type FaqEntry = {
  question: string;
  answer: string;
};

const faqs: FaqEntry[] = [
  {
    question: "Do I need a code to use D-ESPIAL app?",
    answer:
      "You do not require to do anything to use D-ESPIAL. It a no code tool. All you need is to create a free account for free security and safety alerts and subscribe if you need specific alerts and reports.",
  },
  {
    question:
      "How do I subscribe to get specific daily security and safety update in my location?",
    answer: "Tap on the subscribe button and fill in the required information.",
  },
  {
    question: "How can I change or edit my account information?",
    answer:
      "You can change or edit your account information associated to your D-ESPIAL account by going to the edit section on your account from a laptop, desktop or mobile phone.",
  },
  {
    question: "When should I use D-ESPIAL app?",
    answer: "Anytime of the day. It is your 24/7 dependable companion.",
  },
  {
    question:
      "How can I get more security and safety information about an area, local government area, town, city, state, province or country?",
    answer: "Go to subscription options and upgrade your subscription.",
  },
  {
    question: "How do I subscribe for members of my organization or company?",
    answer:
      "Go to subscription options and tap on corporate subscription and follow the instructions.",
  },
  {
    question: "Who should use D-ESPIAL app?",
    answer: "Anyone at any age that cares about personal security and safety.",
  },
];

interface FaqItemProps {
  faq: FaqEntry;
  isOpen: boolean;
  onClick: () => void;
}

const FaqItem: React.FC<FaqItemProps> = ({ faq, isOpen, onClick }) => (
  <div className="border-b border-gray-200 py-6">
    <button
      onClick={onClick}
      className="w-full flex justify-between items-center text-left text-lg font-medium text-gray-900"
    >
      <span>{faq.question}</span>
      <svg
        className={`w-6 h-6 transform transition-transform ${isOpen ? "rotate-180" : ""}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>
    {isOpen && (
      <div className="mt-4 text-base text-gray-600">
        <p>{faq.answer}</p>
      </div>
    )}
  </div>
);

const Faq: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleClick = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-white py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-extrabold text-gray-900">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-xl text-gray-600">
            Can't find the answer you're looking for? Reach out to our support team.
          </p>
        </div>
        <div className="mt-10">
          {faqs.map((faq, index) => (
            <FaqItem
              key={index}
              faq={faq}
              isOpen={openIndex === index}
              onClick={() => handleClick(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faq;
